var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitulos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.333 145.833V183.333L125 170.833L141.667 183.333V145.833M83.3333 158.333H41.6667C37.2464 158.333 33.0072 156.577 29.8816 153.452C26.7559 150.326 25 146.087 25 141.667V58.3333C25 49.1667 32.5 41.6667 41.6667 41.6667H158.333C162.754 41.6667 166.993 43.4226 170.118 46.5482C173.244 49.6738 175 53.913 175 58.3333V141.667C174.997 144.589 174.225 147.46 172.763 149.99C171.3 152.521 169.198 154.622 166.667 156.083M50 75H150M50 100H75M50 125H66.6667M100 125C100 131.63 102.634 137.989 107.322 142.678C112.011 147.366 118.37 150 125 150C131.63 150 137.989 147.366 142.678 142.678C147.366 137.989 150 131.63 150 125C150 118.37 147.366 112.011 142.678 107.322C137.989 102.634 131.63 100 125 100C118.37 100 112.011 102.634 107.322 107.322C102.634 112.011 100 118.37 100 125Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitulos);
export default __webpack_public_path__ + "static/media/titulos.7158e0e481e91924a1c96288d1e06289.svg";
export { ForwardRef as ReactComponent };